export function sanitize(text) {
    if (!text)
        return text;
    var map = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;"
    };
    return text.replace(/[&<>"'/]/g, function (m) { return map[m]; });
}
